export var EFormFieldsNames = /*#__PURE__*/function (EFormFieldsNames) {
  EFormFieldsNames["Name"] = "name";
  EFormFieldsNames["Phone"] = "phone";
  EFormFieldsNames["Email"] = "email";
  EFormFieldsNames["PrivacyPolicyAccepted"] = "privacyPolicyAccepted";
  EFormFieldsNames["AbstractWithPrivacyPolicy"] = "abstractWithPrivacyPolicy";
  EFormFieldsNames["Message"] = "message";
  EFormFieldsNames["Topic"] = "topic";
  EFormFieldsNames["Files"] = "files";
  EFormFieldsNames["OwnerOfferLinkOrId"] = "ownerOfferLinkOrId";
  EFormFieldsNames["OwnerOfferLink"] = "ownerOfferLink";
  EFormFieldsNames["OwnerComplaintType"] = "ownerComplaintType";
  EFormFieldsNames["DuplicateOfferLink"] = "duplicateOfferLink";
  EFormFieldsNames["LoginIssueType"] = "loginIssueType";
  EFormFieldsNames["AddedAds"] = "addedAds";
  EFormFieldsNames["NewPhone"] = "newPhone";
  EFormFieldsNames["PartnerRewardsSource"] = "partnerRewardsSource";
  return EFormFieldsNames;
}({});